(function () {
  'use strict';

  if (window.__suayRccHideBlanksInit) return;
  window.__suayRccHideBlanksInit = true;

  var BLANK_TITLE_PATTERN = /\|\s*blank\b/i;
  var PRODUCT_SELECTOR = '.rcc-search__product';
  var TITLE_SELECTOR = '.rcc-search__product__title';
  var HIDDEN_CLASS = 'suay-rcc-product--hidden';
  var queuePending = false;

  function hideCard(card) {
    if (!card || card.classList.contains(HIDDEN_CLASS)) return;

    card.classList.add(HIDDEN_CLASS);
    card.setAttribute('aria-hidden', 'true');

    card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      if (!el.hasAttribute('data-suay-original-tabindex')) {
        var tabindex = el.getAttribute('tabindex');
        el.setAttribute('data-suay-original-tabindex', tabindex === null ? '' : tabindex);
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function titleForCard(card) {
    var titleEl = card.querySelector(TITLE_SELECTOR);
    return titleEl ? titleEl.textContent || '' : '';
  }

  function scanForBlankCards(root) {
    var cards = [];

    if (root && root.matches && root.matches(PRODUCT_SELECTOR)) {
      cards = [root];
    } else if (root && root.querySelectorAll) {
      cards = Array.prototype.slice.call(root.querySelectorAll(PRODUCT_SELECTOR));
    }

    cards.forEach(function (card) {
      if (BLANK_TITLE_PATTERN.test(titleForCard(card))) {
        hideCard(card);
      }
    });
  }

  function scheduleScan() {
    if (queuePending) return;

    queuePending = true;
    window.requestAnimationFrame(function () {
      queuePending = false;
      scanForBlankCards(document);
    });
  }

  function init() {
    if (!document.body) return;

    scheduleScan();

    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) {
        scheduleScan();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
